import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { EnumSelect } from '../controls/enum-select';
import { ENTRY_STYLE_OPTIONS, LAYOUT_OPTIONS } from './option-constants';
import type { SectionProps } from './types';

export const LayoutSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <>
      <EnumSelect
        label={t['com.streamlain.customApps.viewConfig.layout.type']()}
        data-sl-field="layoutType"
        value={row.layoutType}
        options={LAYOUT_OPTIONS}
        onChange={v => setField('layoutType', v)}
      />
      <EnumSelect
        label={t['com.streamlain.customApps.viewConfig.layout.entryStyle']()}
        data-sl-field="entryStyle"
        value={row.entryStyle}
        options={ENTRY_STYLE_OPTIONS}
        onChange={v => setField('entryStyle', v)}
      />
    </>
  );
};
